import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CommentsDataModule } from '@empathy/comments/data';
import { AutoFocusDirective, EmpathyUiModule } from '@empathy/ui';

import { UiModule } from '@mom/ui';

import { CommentComponent } from './components/comment/comment.component';
import { CommentInputComponent } from './components/comment-input/comment-input.component';
import { CommentsFilterComponent } from './components/comments-filter/comments-filter.component';
import { CommentsListComponent } from './components/comments-list/comments-list.component';
import { HashtagComponent } from './components/hashtag/hashtag.component';

@NgModule({
  declarations: [CommentComponent, CommentsFilterComponent, CommentInputComponent, CommentsListComponent, HashtagComponent],
  imports: [
    CommonModule,
    CommentsDataModule,
    FontAwesomeModule,
    FormsModule,
    EmpathyUiModule,
    MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatChipsModule,
    MatDividerModule,
    MatToolbarModule,
    ReactiveFormsModule,
    AutoFocusDirective
  ],
  providers: [],
  exports: [CommentsListComponent]
})
export class CommentsModule {}
